const Breakpoints = {
    XSmall: '(max-width: 599.99px)',
    Small: '(min-width: 600px) and (max-width: 959.99px)',
    Medium: '(min-width: 960px) and (max-width: 1279.99px)',
    Large: '(min-width: 1280px)'
};

let handlers = [];
const xSmallMedia = window.matchMedia(Breakpoints.XSmall);
const smallMedia = window.matchMedia(Breakpoints.Small);
const mediumMedia = window.matchMedia(Breakpoints.Medium);
const largeMedia = window.matchMedia(Breakpoints.Large);

[xSmallMedia, smallMedia, mediumMedia, largeMedia].forEach((media) => {
    media.addListener((e) => {
        e.matches && handlers.forEach((handler) => handler());
    });
});

export const screenSizes = () => {
    return {
        'screen-x-small': xSmallMedia.matches,
        'screen-small': smallMedia.matches,
        'screen-medium': mediumMedia.matches,
        'screen-large': largeMedia.matches
    };
};

export const onScreenChanged = (handler) => handlers.push(handler);

export const offScreenChanged = (handler) => {
    handlers = handlers.filter((item) => item !== handler);
};

export const getScreenSizeClass = () => {
    const screenSizes = {
        'screen-x-small': xSmallMedia.matches,
        'screen-small': smallMedia.matches,
        'screen-medium': mediumMedia.matches,
        'screen-large': largeMedia.matches
    };
    return Object.keys(screenSizes)
        .filter((cl) => screenSizes[cl])
        .join(' ');
};

export const isScreenLarge = () => Boolean(screenSizes()['screen-large']);
export const isScreenMedium = () => Boolean(screenSizes()['screen-medium']);
export const isScreenSmal = () => Boolean(screenSizes()['screen-small']);
export const isScreenXSmall = () => Boolean(screenSizes()['screen-x-small']);
